import { getPublisherToken } from './get-publisher-token';

export function getCheckoutToken() {
  const searchParams = new URLSearchParams(window.location.search);
  const checkoutToken = searchParams.get('checkout-token') || '';
  return checkoutToken || getPublisherToken();
}
